/**
 * The brand-aware mark shown wherever Ask Docsight speaks for the tenant: the
 * panel header and every bot message row. Mirrors the left nav's own
 * logo-or-letter fallback (`Sidebar.tsx`) — a fetched logo, or the product
 * name's first letter — so the chat surfaces read as the same product mark
 * rather than a second, hardcoded glyph.
 */
import type { Brand } from '../../api/types';

export interface BrandTileProps {
  brand: Brand;
  /** An object URL for the brand's logo, or null to show the letter mark. */
  logoUrl: string | null;
  /** 'header' (28px, panel chrome) or 'message' (22px, per-row mark). */
  size?: 'header' | 'message';
}

export function BrandTile({ brand, logoUrl, size = 'header' }: BrandTileProps): React.JSX.Element {
  const mark = (brand.product_name.trim()[0] ?? 'D').toUpperCase();
  const className =
    size === 'message' ? 'ds-chat-brand-tile ds-chat-brand-tile--sm' : 'ds-chat-brand-tile';

  return logoUrl != null ? (
    <img className={`${className} ds-chat-brand-tile--logo`} src={logoUrl} alt="" aria-hidden="true" />
  ) : (
    <span className={className} aria-hidden="true">
      {mark}
    </span>
  );
}
